module.exports = __webpack_public_path__ + "static/media/screen_2x.5cb67af9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screen_2x.png
// module id = 298
// module chunks = 21